import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import style from './ActiveTradePlanModule.module.css';
import ChartTab from './components/chartTab/ChartTab';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { InPositionTopRow } from './components/topRows/InPositionTopRow';
import { NotInPositionTopRow } from './components/topRows/NotInPositionTopRow';
import { useTabs } from './components/detailsSection/detailsUtils/useTabs';
import { colors } from '../../../../colorVars';

const ActiveTradePlanModule = observer(({ tradePlanId }) => {
  const { tradePlanStore, tradePlanSelectionStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const inPosition = tradePlan?.inPosition ?? null;
  const expanded = tradePlan?.expanded;
  const instrument = tradePlan?.instrument;
  const isPending = tradePlan?.__pending === true;
  const tabProps = useTabs(instrument);
  const clearTabs = tabProps.clearUnusedTabsUponEntry;
  const clearAllTabs = tabProps.clearTabsOnRestart;

  useEffect(() => {
    if (inPosition){
      clearTabs();
    } else {
      clearAllTabs();
    }
  }, [inPosition]);

  if (inPosition === null || !tradePlan) {
    return null;
  }

  const selected = tradePlanSelectionStore.isSelected(tradePlanId);

  return (
    <div
      className={style.container}
      data-tradeplan-id={tradePlanId}
      data-selected={selected ? 'true' : 'false'}
      onClickCapture={() => tradePlanSelectionStore.selectTradePlan(tradePlanId)}
      style={{
        borderColor: inPosition ? colors.green : colors.lightGrey,
      }}
    >
      {inPosition ? (
        <InPositionTopRow
          tradePlanId={tradePlanId}

        />
      ) : (
        <NotInPositionTopRow
          tradePlanId={tradePlanId}

        />
      )}

      {expanded && !isPending && (
        <div>
          <ChartTab tradePlanId={tradePlanId} tabProps={tabProps} />
        </div>
      )}
    </div>
  );
});

ActiveTradePlanModule.propTypes = {
  tradePlanId: PropTypes.any,
};

export default ActiveTradePlanModule;
